export const STORAGE_KEYS = {
  LANG: 'crosslink-lang',
  GRAPH_SETTINGS: 'crosslink-graph-settings',
} as const;

export function isStandalone(): boolean {
  return !!(window as unknown as { __CROSSLINK_STANDALONE__?: boolean }).__CROSSLINK_STANDALONE__;
}

export function getStandaloneData(): unknown {
  return (window as unknown as { __CROSSLINK_DATA__?: unknown }).__CROSSLINK_DATA__;
}

export function imageUrl(filename: string | null | undefined): string {
  if (!filename) return '';
  if (filename.startsWith('data:')) return filename;
  return `/uploads/${filename}`;
}
